/**
 * Formation migration feature flags (ls-8).
 *
 * AUTH_DEV_BYPASS: when true, SPA uses Bearer `auto-auth-token` and skips real login UX.
 *   - Defaults to ON in development, OFF in production builds.
 *   - Set REACT_APP_AUTH_DEV_BYPASS=true to force bypass in production (unsafe for public hosts).
 *
 * FORMATION_DASHBOARD_API: when true (default), Dashboard/AppData merge KPIs from
 * GET /api/dashboard/formation-stats when the request succeeds.
 */
export const AUTH_DEV_BYPASS =
  typeof process.env.REACT_APP_AUTH_DEV_BYPASS === 'string'
    ? process.env.REACT_APP_AUTH_DEV_BYPASS === 'true'
    : process.env.NODE_ENV !== 'production';

export const FORMATION_DASHBOARD_API =
  process.env.REACT_APP_FORMATION_DASHBOARD_API !== 'false';
